import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";

function ConfirmDeleteDialog({
  open,
  onClose,
  deleting,
  confirmTarget,
  onConfirm,
}) {
  return (
    <Dialog open={open} onClose={() => (deleting ? null : onClose)}>
      <DialogTitle>Confirm deletion</DialogTitle>
      <DialogContent>
        {confirmTarget ? (
          <div>
            Are you sure you want to delete <b>{confirmTarget.title}</b>?
          </div>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={deleting}>
          Cancel
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={onConfirm}
          disabled={deleting}
        >
          {deleting ? (
            <CircularProgress size={18} sx={{ color: "#fff" }} />
          ) : (
            "Confirm"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDeleteDialog;
